import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { catchError, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  constructor(private http: HttpClient) {}

  public hasValidToken(): Observable<boolean> {
    return this.http.get(`${environment.urls.api}/subscription-active`).pipe(
      map((response) => !!response),
      catchError(() => of(false)),
    );
  }
}
